module.exports = __webpack_public_path__ + "static/media/V2.204462fd.png";